import { Injectable } from '@angular/core';
import { BaseSchema } from '@res/ngg-core';
import { Typesaurus, TypesaurusCore, schema } from 'typesaurus';

const db = schema(($) => ({
  lossers: $.collection<Losser>(),
  partners: $.collection<Partner>(),
  vehicles: $.collection<Vehicle>(),
  rents: $.collection<Rent>(),
}));

@Injectable({
  providedIn: 'root',
})
export class OrmService {
  public losserCollection: TypesaurusCore.Collection<LosserModel> = db.lossers;
  public parnerCollection = db.partners;
  public vehicleCollection = db.vehicles;
  public rentCollection = db.rents;
}

export type Schema = Typesaurus.Schema<typeof db>;

export type LosserSchema = Schema['lossers'];
export type LosserId = Schema['lossers']['Id'];
export type LosserRef = Schema['lossers']['Ref'];
export type LosserDoc = Schema['lossers']['Doc'];
export type LosserData = Schema['lossers']['Data'];
export type LosserAssignData = Schema['lossers']['AssignData'];
export type LosserModel = Schema['lossers']['Def'];
export type LosserResult = Schema['lossers']['Result'];
export interface Losser extends BaseSchema {
  name: string;
}

export type PartnerId = Schema['partners']['Id'];
export type PartnerRef = Schema['partners']['Ref'];
export type PartnerDoc = Schema['partners']['Doc'];
export type PartnerData = Schema['partners']['Data'];
export type PartnerUpdateData = Schema['partners']['AssignData'];
export type PartnerModel = Schema['partners']['Def'];
export type PartnerResult = Schema['partners']['Result'];
export interface Partner extends BaseSchema {
  isIndividual: boolean;
  name: string;
  address: string;
  taxNumber: string;
  companyRegisterNumber: string;
  mothersName: string;
  birthAddress: string;
  birthDay: Date;
  drivingLicenseData: {
    number: string;
    category: string;
    validTo: Date;
  };
  telephoneNum: string;
  email: string;
}

export type VehicleId = Schema['vehicles']['Id'];
export type VehicleRef = Schema['vehicles']['Ref'];
export type VehicleDoc = Schema['vehicles']['Doc'];
export type VehicleData = Schema['vehicles']['Data'];
export type VehicleModel = Schema['vehicles']['Def'];
export type VehicleResult = Schema['vehicles']['Result'];
export type VehicleUpdateData = Schema['vehicles']['AssignData'];
export interface Vehicle extends BaseSchema {
  type: string;
  licensePlateNumber: string;
  engineNumber: Date;
  chassisNumber: string;
}

export type RentSchema = Schema['rents'];
export type RentId = Schema['rents']['Id'];
export type RentRef = Schema['rents']['Ref'];
export type RentDoc = Schema['rents']['Doc'];
export type RentData = Schema['rents']['Data'];
export type RentUpdateData = Schema['rents']['AssignData'];
export type RentModel = Schema['rents']['Def'];
export type RentResult = Schema['rents']['Result'];
export interface Rent extends BaseSchema {
  isFinal?: boolean;
  state?: string;
  rentPropForm: {
    losser: LosserRef | LosserData;
    partner: PartnerRef | PartnerData;
    vehicle: VehicleRef | VehicleData;
    currency: string;
    rentUnitPrice: string;
    depositAmount: number;
    rentFromTo: {
      from: Date;
      to: Date;
    };
    isAbroadAllowed: boolean;
    allowedAbroadCountries: string;
  };
  /**
   * Declared because they are written. The wizard's signature and photo steps do not double-nest
   * the way the other four do, so they were already being persisted under exactly these names; the
   * model just did not say so, and mapping the rest into `rentPropForm` would have dropped them.
   */
  signatureForm?: { losserSign?: string; renterSign?: string };
  cameraForm?: Record<string, string>;
}
